import React from 'react'
import { formatDateRelative } from '../../../../utilities'

const UpdatedAt = ({ task }) => {
  return (
    <div style={{ whiteSpace: 'nowrap' }}>
      {formatDateRelative(task.updated_at, true)}
    </div>
  )
}

export default React.memo(
  UpdatedAt,
  (prevProps, nextProps) =>
    prevProps.task.updated_at === nextProps.task.updated_at
)
